export default __webpack_public_path__ + "assets/images/a488fb1cf9d7ea925371d088f83c7853.png";